import DomeTurretIcon from "../../assets/product-list-assets/dome-turret.svg";
import type { ProductListGroup } from "../../types";

export const physicalSecurityDomeTurret: ProductListGroup = {
  id: "physicalSecurityDomeTurret",
  title: "productListGroup.domeTurret.title",
  seriesLabel: "modelCompare.seriesLabel.physicalSecurityDomeTurret",
  icon: {
    src: DomeTurretIcon,
    width: 30,
    height: 21,
  },
};
